// What "start again" starts again.
//
// The pause menu is handed one label — "Restart level", "New run", "New game" —
// because the caller is the only thing that knows which mode it is in. The
// confirm screen has to say the same word back in a sentence, and deriving it
// from the label is one source of truth rather than a second prop nobody would
// keep in step with the first.

/** The noun in "Start this ___ again from the beginning." */
export function restartNoun(label: string): string {
  const text = label.toLowerCase();
  if (text.includes("level")) return "level";
  if (text.includes("run")) return "run";
  return "game";
}
